module.exports = __webpack_public_path__ + "static/media/img1.2484fd27.jpg";